export function getDashboardRoute(role, onboardingComplete) {
  switch (role) {
    case 'super_admin':
      return '/group';
    case 'senior_manager':
      return onboardingComplete ? '/group' : '/onboarding/senior';
    case 'manager':
      return onboardingComplete ? '/dashboard' : '/onboarding/manager';
    case 'fuel_manager':
      return onboardingComplete ? '/fuel-dashboard' : '/onboarding/fuel';
    case 'operator':
    case 'driver':
      return '/dashboard';
    default:
      return '/login';
  }
}